import * as constAction from 'root/actionConstants';
import {Map, List, fromJS} from 'immutable';

var defaultState = Map({
  lista: List(),
  rolesUser: List(),
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.ROLES_CLEAR: {
      if(action.payload === 'all')
      return defaultState;
      else if(defaultState.has(action.payload))
      return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad '+action.payload);
        return state;
      }
    }
    case constAction.ROLES_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    default: return state;
  }
}



// WEBPACK FOOTER //
// src/modules/roles/reducer.js